(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name AccountController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('AccountController', AccountController);

    AccountController.$inject = ['$uibModal','$log', '$document','UserService','$scope','upload','AddressService','StripeService'];


    function AccountController($uibModal,$log,$document,UserService,$scope,upload,AddressService,StripeService)
    {

    	var vm = this;
      vm.address = [];
      vm.account = [];
      
      vm.as =  AddressService;
      vm.stripe = StripeService;
      //Zone edit 
      vm.formValid = false;
      vm.editMD = false;
      vm.editCD = false;
      vm.editDD = false;
      vm.sended = false;
      
      vm.loadAddress= function(id){
        for (var i = 0; i < vm.address.length; i++) {
          if(vm.address[i].id==id)
          {
            return {
                          address: vm.address[i].address,
                          city: vm.address[i].city,
                          directoryaddress: vm.address[i].directoryaddress,
                          id: id,
                          isinvoiceaddress: vm.address[i].isinvoiceaddress,
                          iskeyaddress: vm.address[i].iskeyaddress,
                          zip: vm.address[i].zip,
                          country:vm.address[i].country.toString(),
                          name:vm.address[i].name
                        };
          }

        }
      
      };

      vm.upload = function(response)
      {
            vm.reloadAccount();
      };

       vm.reloadAccount = function()
          {
            UserService.getAccount().then(function(data){
              
              vm.account = data.account;

              $scope.$broadcast("refresh_select2");
            });

        };

      vm.reloadAccount();


      vm.getPurpose = function (purpose)
      {
        for (var i = 0; i < vm.account.comunications.length; i++) {
            if(vm.account.comunications[i].purpose==purpose && vm.account.comunications[i].iskey)
            {
              return vm.account.comunications[i].entry;
            }
        }
        return "";

      };

      vm.saveAccount = function(formReg)
      {
        if (vm.sended) {
           return;
        }
         console.log(formReg);
         if (formReg.$valid) {
           vm.sended = true;

          UserService.saveAccount(vm.account).then(function(data){

              vm.reloadAccount();              
                       
                vm.openSaved();

                vm.editCD = false;
                vm.editDD = false;
                vm.editMD = false; 
                vm.sended = false;
          });
        }
      };


        vm.savedModal = "";
        vm.openSaved = function(){
          
            console.log(vm.formValid);
           
            vm.savedModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'saveddata.html',
                  size: 'sm',
                  //backdrop:'static',
                  controller: function($scope) {
                    $scope.closeForm = function(){
                        vm.savedModal.close();
                    };
                  }

            });
          
        };

        vm.removeModal = "";
        vm.openRemove = function(){
            vm.removeModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'removeaccount.html',
                  size: 'sm',
                  //backdrop:'static',
                  controller: function($scope) {
                    $scope.data =vm.account;

                    $scope.deleteForm = function()
                    {
                       UserService.deleteAccount($scope.data).then(function(){
                         vm.removeModal.close();
                         window.location.href = "/site/logout";

                       });
                    };
                    
                    $scope.closeForm = function(){
                        vm.removeModal.close();
                    };
                  }
            });
        };

        vm.accesdataModal = "";
        vm.openAccesdata = function(){
            vm.accesdataModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'editaccessdata.html',
                  size: 'sm',
                  //backdrop:'static',
                  controller: function($scope) {
                    $scope.loading = false;
                    $scope.user={
                      username:vm.account.user.username,
                      cur_pass:"",
                      password:"",
                      reg_reppass:"",
                    };

                    $scope.send = function(form)
                    {
                      if (form.$invalid)return;
                      if($scope.user.password!==$scope.user.reg_reppass)return;

                      $scope.loading = true;
                      UserService.updateUser($scope.user).then(function(data)
                        {
                          
                          $scope.loading = false;
                          if(data.status==200)
                            vm.accesdataModal.close();
                          else
                            $scope.code=-10;
                        });
                    };
                    $scope.closeForm = function(){
                        vm.accesdataModal.close();
                    };
                  }
            });
        };

       //INIT SERVICES 
    vm.as.reloadAddresses();
    
    }
})();